module.exports = __webpack_public_path__ + "img/content6-1.ae91e40d.png";